import { useContext } from "react";
import styled from "styled-components";
import TextFontSize from "./TextFontSize";
import TextFontFamily from "./TextFontFamily";
import TextAlign from "./TextAlign";
import FontStyle from "./FontStyle";
import TextColor from "./TextColor";
import LayersTool from "../LayersTool";
import DeleteTool from "../DeleteTool";
import TextOpacity from "./TextOpacity";
import { VideoEditorContext } from "../../../../../App";
import { ObjectTypes, SceneObject, Text } from "../../../../../types/scene";

const TextActions = () => {
  const { currentScene, handleSceneObjectChange, fontList, selectedFont, handleChangeSelected } =
    useContext(VideoEditorContext);

  const currentObject = currentScene?.objects.find(
    (obj: SceneObject) => obj.object.id === currentScene.activeObjectId && obj.type === ObjectTypes.texts,
  )?.object as Text | undefined;

  return currentObject ? (
    <Wrapper>
      <TextFontSize currentObject={currentObject} />
      <TextFontFamily
        handleSceneObjectChange={handleSceneObjectChange}
        currentObject={currentObject}
        fontList={fontList}
        selectedFont={selectedFont}
        handleChangeSelected={handleChangeSelected}
      />
      {/* <TextLineHeight handleSceneObjectChange={handleSceneObjectChange} currentObject={currentObject} /> */}
      <TextAlign handleSceneObjectChange={handleSceneObjectChange} currentObject={currentObject} />
      <FontStyle handleSceneObjectChange={handleSceneObjectChange} currentObject={currentObject} />
      <TextColor handleSceneObjectChange={handleSceneObjectChange} currentObject={currentObject} />
      <TextOpacity handleSceneObjectChange={handleSceneObjectChange} currentObject={currentObject} />
      <LayersTool />
      <DeleteTool />
    </Wrapper>
  ) : (
    <div />
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export default TextActions;
